import React from "react";
import { motion } from "framer-motion";
import { AlertCircle } from "lucide-react";
import PhoneMockup from "./PhoneMockup";
import { SCREEN_FILTER } from "../../lib/assets";

const CHIPS = [
    "Glúten",
    "Lactose",
    "Leite",
    "Amendoim",
    "Frutos do mar",
    "Soja",
    "Diabetes",
    "Hipertensão",
    "Vegano",
    "Vegetariano",
    "Corantes artificiais",
    "Adoçantes artificiais",
];

export default function MeuFiltro() {
    return (
        <section
            id="meu-filtro"
            data-testid="meu-filtro-section"
            className="relative py-20 md:py-28"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
                    <motion.div
                        className="lg:col-span-5 flex justify-center lg:justify-start"
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.6 }}
                    >
                        <PhoneMockup data-testid="meu-filtro-phone">
                            <img
                                src={SCREEN_FILTER}
                                alt="Tela do app Dentro — configurando restrições e alergias"
                            />
                        </PhoneMockup>
                    </motion.div>

                    <motion.div
                        className="lg:col-span-7"
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                    >
                        <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#16A34A]">
                            Meu Filtro
                        </span>
                        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0B1C3A] tracking-tight">
                            Seu filtro pessoal de segurança.
                        </h2>
                        <p className="mt-5 text-lg text-[#475569] leading-relaxed max-w-xl">
                            Marque alergias, restrições e ingredientes que você
                            quer evitar. O Dentro avisa imediatamente quando um
                            produto tiver algo incompatível com você.
                        </p>

                        <div className="mt-7 flex flex-wrap gap-2.5">
                            {CHIPS.map((c) => (
                                <span
                                    key={c}
                                    data-testid={`filter-chip-${c.toLowerCase().replace(/\s+/g, "-")}`}
                                    className="px-4 py-2 rounded-full bg-white border border-slate-200 text-sm font-semibold text-[#0B1C3A] hover:border-[#16A34A] hover:text-[#16A34A] transition-colors"
                                >
                                    {c}
                                </span>
                            ))}
                        </div>

                        <div
                            data-testid="filter-alert"
                            className="mt-8 rounded-3xl border border-[#DC2626]/25 bg-[#DC2626]/5 p-5 flex gap-4 items-start max-w-xl"
                        >
                            <div className="h-11 w-11 rounded-2xl bg-[#DC2626] text-white grid place-items-center shrink-0">
                                <AlertCircle size={20} strokeWidth={2.4} />
                            </div>
                            <div>
                                <div className="text-[11px] uppercase tracking-[0.2em] font-extrabold text-[#DC2626]">
                                    🚨 Alerta do Meu Filtro
                                </div>
                                <p className="mt-1.5 font-display text-lg font-bold text-[#0B1C3A] leading-snug">
                                    Este produto contém glúten, que está marcado
                                    no seu perfil.
                                </p>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
